/**
 * @desc 批量转换sku负责人
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<string>;
export function request(
  body: Array<defs.basics.PlmSkuManageEditRequestDto>,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/product/sku/batchChangeSkuManager`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
